import {
  JobSupport3fdjh0rbee4be as JobSupport,
  get_COMPLETING_WAITING_CHILDREN3nnjgv5wv89p1 as get_COMPLETING_WAITING_CHILDREN,
} from './JobSupport.mjs';
import {
  Key_instancepi2bbb0csu5f as Key_instance,
  Job29shfjfygy86k as Job,
} from './Job.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_classSimpleName2jgk6lzg9ft1 as get_classSimpleName } from './Debug.mjs';
import {
  CompletedExceptionally3itrk74dxkv9s as CompletedExceptionally,
  toState1lqvgl5d0bogr as toState,
} from './CompletionState.mjs';
import { handleCoroutineExceptionv1m1bdk4j2te as handleCoroutineException } from './CoroutineExceptionHandler.mjs';
import { get_coroutineName3a0vy840b4l1i as get_coroutineName } from './CoroutineContext.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var AbstractCoroutineClass;
function AbstractCoroutine() {
  if (AbstractCoroutineClass === VOID) {
    class $ extends JobSupport() {
      constructor(parentContext, initParentJob, active) {
        super(active);
        if (initParentJob) {
          this.sw(parentContext.cd(Key_instance));
        }
        this.vw_1 = parentContext.in(this);
      }
      qc() {
        return this.vw_1;
      }
      ww() {
        return this.vw_1;
      }
      xw() {
        return super.xw();
      }
      yw(value) {
      }
      zw(cause, handled) {
      }
      ax() {
        return get_classSimpleName(this) + ' was cancelled';
      }
      bx(state) {
        if (state instanceof CompletedExceptionally()) {
          this.zw(state.cx_1, state.ex());
        } else {
          this.yw(state);
        }
      }
      sc(result) {
        var state = this.fx(toState(result));
        if (state === get_COMPLETING_WAITING_CHILDREN())
          return Unit_instance;
        this.gx(state);
      }
      gx(state) {
        return this.hx(state);
      }
      ix(exception) {
        handleCoroutineException(this.vw_1, exception);
      }
      jx() {
        var tmp0_elvis_lhs = get_coroutineName(this.vw_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return super.jx();
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var coroutineName = tmp;
        return '"' + coroutineName + '":' + super.jx();
      }
      kx(start, receiver, block) {
        start.nx(block, receiver, this);
      }
    }
    initMetadataForClass($, 'AbstractCoroutine', VOID, VOID, [Job(), Continuation()], [0]);
    AbstractCoroutineClass = $;
  }
  return AbstractCoroutineClass;
}
//region block: exports
export {
  AbstractCoroutine as AbstractCoroutine2jzyhqo91sb0o,
};
//endregion

//# sourceMappingURL=AbstractCoroutine.mjs.map
